import React, { useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./OpeningDays.css";
import moment from "moment";
// import { FiExternalLink } from "react-icons/fi";
import { Zoom } from "react-awesome-reveal";

const OpeningDays = () => {
  const [activeDate, setActiveDate] = useState(new Date());
  const currentMonth = activeDate.getMonth();

  const monthMessages = {
    8: "The evening of Friday the 18th of September will be a wine tasting with matching courses.",
    11: "Wednesday the 9th of December will be lunch only (serving our Christmas menu).",
  };

  //full = true
  const datesOpenAndAvailability = {
    "16-10-2026": true,
    "17-10-2026": true,
    "23-10-2026": true,
    "24-10-2026": true,
    "20-11-2026": false,
    "21-11-2026": false,
    "04-12-2026": false,
    "05-12-2026": false,
    "09-12-2026": false,
    "11-12-2026": false,
    "12-12-2026": false,
    "16-12-2026": false,
    "17-12-2026": false,
    "18-12-2026": false,
    "19-12-2026": false,
  };

  const datesCateringEvent = [
    "30-10-2026",
    "31-10-2026",
    "06-11-2026",
    "07-11-2026",
    "13-11-2026",
    "14-11-2026",
    "27-11-2026",
    "28-11-2026",
  ];

  const dateMinus1 = new Date();
  dateMinus1.setDate(dateMinus1.getDate() - 1);

  return (
    <Zoom triggerOnce={true}>
      <div className="opening_times">
        <div className="key_container">
          <div className="key_item">
            <div className="color_key"></div>
            <span className="key_txt">Open</span>
          </div>
          <div className="key_item">
            <div className="color_key one" style={{ opacity: "0.4" }}></div>
            <span className="key_txt">Fully Booked</span>
          </div>
          <div className="break_keys"></div>
          <div className="key_item">
            <div
              className="color_key"
              style={{ backgroundColor: "#cc3c08" }}
            ></div>
            <span className="key_txt">Catering Event</span>
          </div>
          <div className="key_item">
            <div
              className="color_key"
              style={{ backgroundColor: "white", border: "1px solid black" }}
            ></div>
            <span className="key_txt">Closed</span>
          </div>
        </div>
        <div className="break"></div>
        {/* Calendar with overlay */}
        <div className="calendar_wrapper">
          {/* Show overlay message during Jan–Mar (months 0,1,2) */}
          {/* {(activeDate.getMonth() >= 0 && activeDate.getMonth() <= 2) && (
            <div className="calendar_overlay" aria-live="polite">
              We are currently closed from January to March inclusive
            </div>
          )} */}
          <Calendar
            className="react_calendar"
            onActiveStartDateChange={({ activeStartDate }) =>
              setActiveDate(activeStartDate)
            }
            minDate={new Date(Date.now())}
            maxDate={new Date(2026, 11, 31)}
            defaultView={"month"}
            prevLabel="‹"
            prev2Label={null}
            nextLabel="›"
            next2Label={null}
            selectRange={false}
            maxDetail={"month"}
            showNeighboringMonth={false}
            tileClassName={({ date }) => {
              if (
                datesOpenAndAvailability[moment(date).format("DD-MM-YYYY")] ===
                  true &&
                date >= dateMinus1
              ) {
                return "full";
              }

              if (
                moment(date).format("DD-MM-YYYY") in datesOpenAndAvailability &&
                date >= dateMinus1
              ) {
                return "highlight";
              }

              if (
                datesCateringEvent.includes(
                  moment(date).format("DD-MM-YYYY")
                ) &&
                date >= dateMinus1
              ) {
                return "highlightCatering";
              }
            }}
          />
        </div>
        <div className="break"></div>
        <Zoom
          style={{ margin: "0 15px 0 15px", textAlign: "center" }}
          triggerOnce={true}
        >
          {monthMessages[currentMonth] && (
            <span className="limited_txt">{monthMessages[currentMonth]}</span>
          )}
        </Zoom>
      </div>
    </Zoom>
  );
};

export default OpeningDays;
